<template>
    <div v-if="dataExists">
        <slot name="dataComponent"></slot>
    </div>
    <div v-else-if="loading" class="d-flex flex-column justify-content-center align-items-center">
        <slot name="loadingComponent"></slot>
    </div>
    <div v-else-if="error" class="d-flex flex-column justify-content-center align-items-center">
        <slot name="errorComponent"></slot>
    </div>
    <div v-else-if="dataEmpty" class="d-flex flex-column justify-content-center align-items-center">
        <slot name="emptyComponent"></slot>
    </div>
</template>
<script>
export default {
    name: 'AsyncWrapper',
    props: {
        wrapperClass: {
            type: String,
            default: ''
        },
        data: {
            type: [Boolean, Object, Array],
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        error: {
            type: [Boolean, String],
            required: true
        }
    },
    computed: {
        dataExists() {
            return (typeof this.data === 'object' && Object.keys(this.data).length > 0) || (this.data && Array.isArray(this.data) && this.data.length > 0)
        },
        dataEmpty() {
            return !this.data || (this.data && Array.isArray(this.data) && this.data.length === 0)
        }
    }
}
</script>
<style lang="scss" scoped>
.d-flex {
    flex: 1;
}
</style>
